import { useTimezone } from '@app/core/hooks/useTimezone';
import { useTzFormat } from '@app/core/hooks/useTzFormat';
import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import { minutesToMs } from '@mi-front/core';
import { Button } from '@mui/material';
import { useJumpStream } from '../../../../hooks/navigation/useJumpStream';
import { useStreamUserDefinedRange } from '../../../../stores/stream-screen.store';

/**
 * Shared button used inside TimeMove Backwards/Forwards ButtonGroups.
 * Jumps the stream by the given minutes (positive = forward, negative = backward)
 * using useJumpStream. Keeps consistent styling across time step actions.
 */
export function TimeMoveButton({
  label,
  minutes,
  disabled = false,
}: {
  label: string;
  /** Minutes to move: positive = forward, negative = backward */
  minutes: number;
  disabled?: boolean;
}) {
  const capture = usePostHogCapture();
  const tz = useTimezone();
  const formatTz = useTzFormat();
  const { from, to } = useStreamUserDefinedRange();
  const jumpStream = useJumpStream();

  const handleClick = () => {
    capture('logger:time_jumped', {
      direction: minutes >= 0 ? 'forward' : 'backward',
      minutes,
      timezone: tz,
      from: formatTz(from, 'YYYY-MM-DD HH:mm:ss Z'),
      to: formatTz(to, 'YYYY-MM-DD HH:mm:ss Z'),
    });

    jumpStream(minutesToMs(minutes));
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled}
      size="large"
      sx={{ textTransform: 'none', width: '56px', fontWeight: '400' }}
    >
      {label}
    </Button>
  );
}
